import angular from 'angular';

(function() {
    'use strict';
    angular.module('app.core').factory('Report', ReportData);

    ReportData.$inject = ['$translate'];

    /* @ngInject */
    function ReportData($translate) {
        Report.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            getTypeLabel: getTypeLabel,
            getXlsFilename: getXlsFilename
        };

        function Report(reportData) {
            if (!reportData) {
                this.buildEmpty();
            } else {
                this.build(reportData);
            }
        }

        return Report;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.fileId = null;
            this.date = null;
            this.type = null;
            this.name = null;
        }

        function build(reportData) {
            this.id = reportData.id || null;
            this.date = reportData.creationDate || null;
            this.type = reportData.action || null;
            this.name = reportData.param1 || null;
            this.fileId = reportData.param2 || null;
        }

        function getTypeLabel() {
            if (this.type) {
                return $translate.instant('principal.reports.types.' + angular.lowercase(this.type));
            }
            return this.type;
        }

        function getXlsFilename() {
            var xlsName = '';
            if (this.name) {
                xlsName = this.name.replace(/.csv$/i, '.xlsx');
            }
            return xlsName;
        }
    }
})();
